/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "service/channel"], function (require, exports, channel_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AsyncCallChannel = void 0;
    channel_1 = __importDefault(channel_1);
    class AsyncCallChannel extends channel_1.default {
        constructor(channel, options) {
            super({}, {});
            this.options = options || {};
            this.asyncCallHandler = channel === null || channel === void 0 ? void 0 : channel.asyncCallHandler;
        }
        call(path, request, responseObserver, formatOptions, callHeaders, options) {
            const promise = this.createDeferredCallFinishedPromise(this, undefined);
            let handlerOptions = Object.assign({}, this.options, { headers: callHeaders, callOptions: options });
            const responsePromise = this.asyncCallHandler(path, request, handlerOptions);
            responsePromise.then(response => {
                this.success(response, promise, responseObserver, undefined);
            }, error => {
                this.error(error, promise, responseObserver);
            });
            return promise;
        }
    }
    exports.AsyncCallChannel = AsyncCallChannel;
});
